{
  "accountInformationText": "Kişisel hesap bilgilerinizi aşağıdan güncelleyin.",
  "accountSettings": "Hesap Ayarları",
  "accountStatus": "Hesap Durumu",
  "accountStatusText": "Hesabınız şu anda iyi durumda.",
  "active": "Aktif",
  "administrator": "Yönetici",
  "backupCodeFailed": "Yedek kod doğrulaması başarısız oldu.",
  "backupCodes": "Yedek Kodlar",
  "backupCodesWarning": "Bu kodları güvenli bir şekilde saklayın. Her yedek kod yalnızca bir kez kullanılabilir.",
  "changePassword": "Şifreyi Değiştir",
  "confirmPassword": "Şifreyi Onayla",
  "copyBackupCodes": "Yedek Kodları Kopyala",
  "currentPassword": "Mevcut Şifre",
  "darkMode": "Koyu Mod",
  "depositWithdrawalAlerts": "Para Yatırma & Çekme Uyarıları",
  "disable2FA": "2FA'yı Devre Dışı Bırak",
  "disable2fa": "Google Authenticator'ı Devre Dışı Bırak",
  "downloadBackupCodes": "Yedek Kodları İndir",
  "emailNotifications": "E-posta Bildirimleri",
  "enterAuthenticatorCode": "Authenticator uygulamanızdan 6 haneli kodu girin",
  "enterAuthenticatorCodeFirst": "Lütfen önce authenticator kodunu girin.",
  "enterSixDigitCode": "6 haneli kodu girin",
  "goToKycVerification": "KYC Doğrulamasına Git",
  "googleAuthenticator2fa": "Google Authenticator (2FA)",
  "googleAuthenticator2faText": "Google Authenticator kullanarak hesabınıza ekstra bir güvenlik katmanı ekleyin.",
  "googleAuthenticatorDisabled": "Google Authenticator devre dışı bırakıldı.",
  "googleAuthenticatorEnabled": "Google Authenticator etkinleştirildi.",
  "inactive": "Pasif",
  "invalidCode": "Geçersiz kod. Lütfen tekrar deneyin.",
  "invalidVerificationCode": "Geçersiz doğrulama kodu.",
  "kycStatusText": "Tüm hesap özelliklerinin kilidini açmak için kimlik doğrulamasını tamamlayın.",
  "language": "Dil",
  "languagePreferencesText": "Hesabınızda kullanılacak dili seçin.",
  "languageSettings": "Dil Ayarları",
  "lightMode": "Açık Mod",
  "loading": "Yükleniyor...",
  "loginAlerts": "Giriş Uyarıları",
  "manualSetupKey": "Manuel Kurulum Anahtarı",
  "newBackupCodesGenerated": "Yeni yedek kodlar oluşturuldu. Bunları güvenli bir yerde saklayın.",
  "newPassword": "Yeni Şifre",
  "notificationPreferences": "Bildirim Tercihleri",
  "notificationPreferencesText": "Almak istediğiniz uyarıları seçin.",
  "notificationSettings": "Bildirim Ayarları",
  "owner": "Sahip",
  "ownerControlCenter": "Sahip Kontrol Merkezi",
  "ownerDisableBlocked": "Sahip hesabı Google Authenticator'ı devre dışı bırakamaz.",
  "p2pAlerts": "P2P Uyarıları",
  "p2pOrderAlerts": "P2P Emir Uyarıları",
  "pushNotifications": "Push Bildirimleri",
  "regenerateBackupCodes": "Yedek Kodları Yenile",
  "require2FASetup": "Devam etmeden önce Google Authenticator kurulumu gereklidir.",
  "role": "Rol",
  "saveBackupCodes": "Yedek Kodları Kaydet",
  "saveChanges": "Değişiklikleri Kaydet",
  "saving": "Kaydediliyor...",
  "scanQrCode": "Bu QR Kodu Tarayın",
  "scanQrCodeAuthenticator": "Bu QR kodu authenticator uygulamanızla tarayın",
  "securityAlerts": "Güvenlik Uyarıları",
  "securityRules": "Güvenlik Kuralları",
  "securitySettings": "Güvenlik Ayarları",
  "selectLanguage": "Dil Seç",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "settingRuleBotProtection": "Bu hesapta otomatik bot etkinliği koruması aktiftir.",
  "settingRuleDepositReview": "Büyük para yatırma işlemleri bakiyenize yansımadan önce incelenir.",
  "settingRuleKyc": "Para çekme onayından önce kimlik doğrulaması gereklidir.",
  "settingRuleManualReview": "Şüpheli etkinlik manuel bir güvenlik incelemesini tetikleyebilir.",
  "settingRuleWalletMatch": "Para çekme işlemleri doğrulanmış bir cüzdan adresiyle eşleşmelidir.",
  "settingsSubtitle": "Hesabınızı, dilinizi, kimlik doğrulamanızı ve güvenliğinizi yönetin.",
  "settingsTitle": "Ayarlar ve Güvenlik",
  "settingsUpdateFailed": "Ayarlar güncellenemedi.",
  "settingsUpdated": "Ayarlar başarıyla güncellendi.",
  "setup2FA": "Google Authenticator Kur",
  "setupGoogleAuthenticator": "Google Authenticator Kur",
  "systemDefault": "Sistem Varsayılanı",
  "theme": "Tema",
  "twoFaSetupFailed": "İki faktörlü kimlik doğrulama kurulumu başarısız oldu.",
  "twoFactorAuthentication": "Google Authenticator (2FA)",
  "twoFactorDescription": "Hesabınızı Google Authenticator ile koruyun.",
  "twoFactorDisabled": "İki Faktörlü Kimlik Doğrulama Devre Dışı Bırakıldı",
  "twoFactorDisabledSuccess": "Google Authenticator başarıyla devre dışı bırakıldı.",
  "twoFactorEnabled": "İki Faktörlü Kimlik Doğrulama Etkinleştirildi",
  "twoFactorSecurity": "İki Faktörlü Güvenlik",
  "twoFactorSecurityText": "Daha güçlü hesap koruması için iki faktörlü kimlik doğrulamayı etkinleştirin.",
  "twoFactorSetupFailed": "2FA kurulumu başarısız oldu.",
  "twoFactorVerified": "Google Authenticator başarıyla etkinleştirildi.",
  "user": "Kullanıcı",
  "verificationCode": "Doğrulama Kodu",
  "verify2FA": "Doğrula ve Etkinleştir",
  "verifyAndEnable": "Doğrula ve Etkinleştir"
}